import { render, staticRenderFns } from "./CategoryAdmin.vue?vue&type=template&id=df10e7d0&"
import script from "./CategoryAdmin.vue?vue&type=script&lang=js&"
export * from "./CategoryAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports